import IUser from '../interfaces/IUser';

export const getLocalUser = (): IUser => {
  const user: IUser = {
    id: '',
    email: '',
    name: '',
    profile: {
      name: '',
      image: '',
    },
    emailVerified: false,
  };

  const localUserData = localStorage.getItem('userData');

  if (localUserData) {
    const userData = JSON.parse(localUserData);
    user.id = userData.id || '';
    user.email = userData.email || '';
    user.name = userData.name || '';
    user.profile.name = userData.profile.name || '';
    user.profile.image = userData.profile.image || '';
    user.emailVerified = userData.emailVerified || false;
  }

  return user;
};

export const setLocalUser = (userData: IUser): IUser => {
  const localUserData = JSON.stringify(userData);
  localStorage.setItem('userData', localUserData);

  return userData;
};

export const setTokenExpire = (token_expires: string): void => {
  let expires_seconds = 300;
  if (token_expires) {
    const tokenDate = new Date(token_expires);
    expires_seconds = tokenDate.getTime() - 120;
  }
  const dateNow = new Date();
  dateNow.setSeconds(dateNow.getSeconds() + expires_seconds);
  localStorage.setItem('token_expires', dateNow.getTime().toString());
};

export const getTokenExpire = (): string => {
  const token_expires = localStorage.getItem('token_expires');
  if (token_expires) {
    return token_expires;
  }

  const dateNow = new Date();
  return dateNow.getTime().toString();
};

export const userLogout = (): boolean => {
  localStorage.removeItem('userData');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('firebaseToken');

  return true;
};

export const getAccessToken = (): string => {
  const accessToken = localStorage.getItem('accessToken');

  if (accessToken) {
    return accessToken;
  }

  return '';
};

export const setAccessToken = (accessToken: string): void => {
  localStorage.setItem('accessToken', accessToken);
};

export const getFirebaseToken = (): string => {
  const firebaseToken = localStorage.getItem('firebaseToken');

  if (firebaseToken) {
    return firebaseToken;
  }

  return '';
};

export const setFirebaseToken = (accessToken: string): void => {
  localStorage.setItem('firebaseToken', accessToken);
};
